import { createUseStyles } from '../../theme/theming';

const nextImageRendererStyles = createUseStyles(() => ({
  '@media (max-width: 640px)': {
    imageContainer: {
      maxWidth: '100%'
    }
  },

  '@media (min-width: 641px) and (max-width: 1280px)': {
    imageContainer: {
      maxWidth: '75%'
    }
  },

  '@media (min-width: 1281px)': {
    imageContainer: {
      maxWidth: '50%'
    }
  }
}));

export default nextImageRendererStyles;
